<template>
  <div class="add-comment-container fix-footer">
    <div class="reply">
      <div  class="textarea" contenteditable="true" ref="textvalue"  :placeholder="obj.active ? '回复'+obj.user.user_nick : '发表评论'"  @input="changecontent" @focus="focus"></div>
      <button class="button" @click="send" v-show="!obj.active" :style="{background:isHaveVal ? '#00B097' : '#E0EAE8'}">发送</button>
      <button  class="button" @click="send" v-show="obj.active" :style="{background:isHaveVal ? '#00B097' : '#E0EAE8'}">回复</button>
    </div>
    <div class="mask" v-if="showMask" @click.stop="showMask = false"></div>
  </div>
</template>

<script>
import Pubsub from 'pubsub-js'
import showBindPhone from "@ivy/fts/showBindPhone"
export default {
  data() {
    return {
      contentVal: '',
      isHaveVal: false,
      content: '',
      obj: {},
      showMask: false
    }
  },
  mounted() {
    Pubsub.subscribe('getobj', (msg, obj) => {
      this.obj = obj
    })
  },
  methods: {
    async send() {
      if (!this.$store.logined.token) {
        // 用户尚未注册
        let logined = await showBindPhone(this.$store.bindPhoneConfig)
        if (!logined || !logined.token) return
      }
      if (!this.isHaveVal) return
      let { lessonId } = this.$route.query
      let r = await this.$axios.post(`/api/mobile/sns/sns2/addComment${this.obj.id ? 'Sub' : ''}`, {
        product_type: 'k_course',
        product_id: lessonId,
        content: this.contentVal,
        comment_id: this.obj.comment_id,
        to_mem_id: this.obj.isRateSon ? this.obj.user.mem_id : undefined
      })
      this.setDefault()

      this.$emit('refresh', r.data)
    },
    changecontent(e) {
      [this.contentVal, this.isHaveVal] = [e.target.textContent, e.target.textContent]
    },
    setDefault() {
      this.$refs.textvalue.textContent = ''
      this.isHaveVal = false
      this.contentVal = ''
      this.showMask = false
      this.obj = {}
    },
    focus() {
      this.showMask = true
    }
  },
  beforeDestroy() {
    Pubsub.clearAllSubscriptions()
  }
}
</script>

<style lang="less">
  @import url('../../common.less');
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }
  .reply{
    position: fixed;
    left: 0;
    bottom: 0;
    background:#f1f1f1;
    width: 20.29rem;
    padding: .47rem .88rem;
    z-index: 101;
    display: flex;
    align-items: flex-end;
    .textarea{
      flex: 1;
      max-height: 3.91rem;
      padding: .35rem .59rem;
      outline: 0;
      background:#ffffff;
      border-radius:6px;
      word-wrap: break-word;
      overflow-x: hidden;
      overflow-y: auto;
      font-family: PingFangSC-Regular;
      font-size: .82rem;
      color: #222222;
      margin-right: 10px;
      &:empty::before{
        content: attr(placeholder);
        color: #888;
      }
    }
    .button{
      // position: absolute;
      // right: .88rem;
      // bottom: .47rem;
      background:#78e182;
      border-radius: 30px;
      width:3.18rem;
      height:1.76rem;
      font-family:@normalFontWeight;
      font-size:.88rem;
      color:#ffffff;
      text-align:bottom;
      border: 0;
    }
  }
</style>
